export default (str, length = 120, ending = " [...]") => {
  if (str.length > length) {
    let trimmed = str.substring(0, length);
    return trimmed.substr(0, Math.min(trimmed.length, trimmed.lastIndexOf(" "))) + ending;
  } else {
    return str;
  }
};
